import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, Autocomplete, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './resource-assign.css'
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';

const ResourceAssignment = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [listType, setListType] = useState('Resource Assignment')
    const [resource, setResource] = useState('');
    const [date, setDate] = useState(new Date());
    const [deleteModal, setDeleteModal] = useState(false)
    const [assignmentdrop, setAssignmentDrop] = useState([]);
		const [positiondrop, setPositionDrop] = useState([]);
		const [vehicledrop, setVehicleDrop] = useState([]);
		const [vehicle, setVehicle] = useState('');
    const [assignment, setAssignment] = useState('');
    const [assignmentList, setAssignmentList] = useState('');
    const [searchResult, setSearchResult] = useState('');
    const [deleteAssign, setDeleteAssign] = useState({});

    const columns = [
        {
            field: 'Resource', headerName: 'Resource', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.resource?.SO_Desc ? params?.row?.resource?.SO_Desc  : params?.row?.Resource.charAt(0).toUpperCase() + params?.row?.Resource.slice(1)}
                        className='resource-chip' />
                )
            }
        },

        {
            field: 'Assignment_date', headerName: 'Assignment Date', flex: 1, minWidth: 150,
            valueGetter: (params) => {
                return moment(params?.row?.Assignment_Date).format('MM/DD/YY');
            }
        },

        {
            field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.assignment?.SO_Desc}
                        className='assignment-chip' />
                )
            }
        },

				{
            field: 'Vehicle', headerName: 'Vehicle', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.vehicle?.SO_Desc ? params?.row?.vehicle?.SO_Desc  : params?.row?.Vehicle}
                        className='vehicle-chip' />
                )
            }
        },

        {
            field: 'assignment_time', headerName: 'Assignment Time', flex: 1, minWidth: 200,
            valueGetter: (params) => { return varFormatTime(params?.row?.date_for_frontend?.create_time, user?.Time_Format) }
        },
        {
            field: 'action', headerName: 'Actions', flex: 1, maxWidth: 130,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setDeleteModal(true)
                                setDeleteAssign(params?.row)
                            }}
                        />

                    </Box>
                );
            },
        }
    ]

    const addAssignment = () => {
        const body = {
            'Resource': resource?.value,
            'Assignment_Date': moment(date).format('MM/DD/YYYY'),
            'Assignment': assignment?.value,
						'Vehicle': vehicle?.value,
        }
        ApiService.post('/ra/add', body)
            .then((data) => {
                toast.success(data?.message)
                setResource('');
                setAssignment('');
								setVehicle('');
                setDate(new Date());
                getAssignmentList()
            })
            .catch((error) => {
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.message)
                }
            })
    }

    const getAssignmentList = (loader = true) => {
        const body = {
            'search': searchResult,
        }
        if (loader) {
            setLoading(true);
        }
        ApiService.post('/ra/list', body)
            .then((data) => {
                const rowsWithIds = data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];

                setAssignmentList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getAssignmentDropDown = () => {
        setLoading(true);
        ApiService.get('/getAssignment')
            .then(({ data }) => {
                var assignArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
                setAssignmentDrop(assignArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

		const getPositionDropDown = () => {
			  setLoading(true);
        ApiService.get('/getPosition')
            .then(({ data }) => {
                var assignArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
                setPositionDrop(assignArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
		}

		const getVehicleDropDown = () => {
				setLoading(true);
				ApiService.get('/getVehicles')
						.then(({ data }) => {
								var assignArr = data?.data.map((assign) => { return { label: assign.SO_Desc, value: assign.SO_Value } })
								setVehicleDrop(assignArr)
								setLoading(false);
						})
						.catch((e) => {
								setLoading(false);
						})
		}

    const deleteAssignment = () => {
        const body = {
            'Resource': deleteAssign?.Resource,
            'Assignment_Date': moment(deleteAssign?.Assignment_Date).format('MM/DD/YYYY'),
            'Assignment': deleteAssign?.Assignment,
        }
        ApiService.post('/ra/delete', body)
            .then((data) => {
                setDeleteAssign({})
                setDeleteModal(false)
                toast.success(data.message)
                getAssignmentList()
            })
            .catch((err) => {
                toast.error(err?.data?.error)
            })
    }

    useEffect(() => {
        getAssignmentList()
        getAssignmentDropDown()
				getPositionDropDown()
				getVehicleDropDown()
    }, [])

    useEffect(() => {
        getAssignmentList(false)
    }, [searchResult])

    return (
        <>
            <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                <Grid container spacing={2} className='align-items-center'>

                    {/* Heading */}
                    <Grid item xs={10} md={4}>
                        <Typography variant="h5">Resource Assignment</Typography>
                    </Grid>

                    {/* Schedule Override Button */}
                    <Grid item xs={6} sm={6} md={'auto'}>
                        <Link to='/firehouse/schedule-override' style={{ textDecoration: 'none' }}>
                            <div className={listType == 'Schedule Override' ? 'tab-active px-4' : 'tab-white px-4'}
                                onClick={() => setListType('Schedule Override')}>
                                Schedule Override
                            </div>
                        </Link>
                    </Grid>

                    {/* Resource Assignment Button */}
                    <Grid item xs={6} sm={6} md={'auto'}>
                        <Link to='/firehouse/resource-assignment' style={{ textDecoration: 'none' }}>
                            <div className={listType == 'Resource Assignment' ? 'tab-active px-4' : 'tab-white px-4'}
                                onClick={() => setListType('Resource Assignment')}>
                                Resource Assignment
                            </div>
                        </Link>
                    </Grid>

                    <Grid container className='p-4' spacing={2}>

												{/* Position */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Position</label>
                            <Autocomplete
                                options={positiondrop}
                                onChange={(event, newValue) => setResource(newValue)}
                                value={resource}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Position"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* Assignment Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>Assignment Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={moment(date).format('MM/DD/YYYY')}
                                    value={date}
                                    onChange={(e) => setDate(e)}
                                    minDate={new Date()}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Assignment */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Assignment</label>
                            <Autocomplete
                                options={assignmentdrop}
                                onChange={(event, newValue) => setAssignment(newValue)}
                                value={assignment}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Assign To"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

												{/* Vehicle */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Vehicle</label>
                            <Autocomplete
                                options={vehicledrop}
                                onChange={(event, newValue) => setVehicle(newValue)}
                                value={vehicle}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Vehicle (Optional)"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                    {/* Submit Button */}
                    <Grid container gap={2} className='justify-content-end'>
                        <Grid item xs={6} md={'auto'}>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='px-2 mt-1' style={{ marginRight: '24px' }}
                                onClick={() => addAssignment()}
                            >
                                Submit
                            </ButtonTheme>
                        </Grid>

                    </Grid>
                </Grid>
            </Paper>

            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h5">List of Resource Assignment</Typography>
                        </Grid>

                        {/* Search field */}
                        <Grid item xs={12} sm={12} md={3}>
                            <TextField
                                variant="outlined"
                                placeholder="Search"
                                onChange={(e) => setSearchResult(e.target.value)}
                                className="w-100"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        height: '48px',
                                        fontSize: '14px',
                                        marginRight: '10px',
                                    },
                                }}
                            />
                        </Grid>

                    </Grid>

                    {(!assignmentList || assignmentList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No resource assigned
                            </span>
                        </div>
                        :
                        <>
                            <div className='mt-4'>
                                <MyTable
                                    rows={assignmentList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                />
                            </div>
                        </>
                    }
                    {/* Delete Modal */}
                    <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Assignment</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div style={{ color: '#555555' }}>
                                Are you sure you want to delete this Assignment?
                            </div>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setDeleteModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                        onClick={deleteAssignment}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </Col>

                            </Row>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}
        </>
    )
}

export default ResourceAssignment